/*
 * @Author: DQL
 * @Date: 2020-03-09 17:05:52
 * @LastEditors: DQL
 * @LastEditTime: 2021-03-16 10:15:55
 * @Description: file content
 */
/** ****************cookie*********************/
/*
cookie的组成部分:
名称:唯一值,不区分大小写,必须经过URL编码
值:必须经过URL编码
域:只是改cookie在哪个域中是有效的.
路径:如果cookie的路径在www.guo.com中能访问,那么在www.yan.com页面就不会发送cookie.即使cookie来自同一个域中的
失效时间:在什么时间点被删除
安全标志:指定后,cookie只有在使用ssl链接的时候才发送到服务器.
域,路径,失效时间和secure标志都是服务器给浏览器的指示
CookieUtil.set('name', 'guoyansi');//设置
CookieUtil.get('name');//获取
CookieUtil.unset('name');//删除
*/
const CookieUtil = {
  get (name) { // 读取
    var cookieName = encodeURIComponent(name) + '=';
    var cookieStart = document.cookie.indexOf(cookieName);
    var cookieValue = null;
    if (cookieStart > -1) {
      var cookieEnd = document.cookie.indexOf(';', cookieStart); // 从cookieStart开始检索字符串';'
      if (cookieEnd === -1) { // 没有检索到
        cookieEnd = document.cookie.length;
      }
      cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd));
    }
    return cookieValue;
  },
  /*
     设置
     */
  set (name, value, expires, path, domain, secure) { // 键名,键值,保存时间,路径,域,失效日期
    var cookieText = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    // 确保path正确
    cookieText += '; path=' + (path || '/');

    if (expires instanceof Date) {
      cookieText += '; expires=' + expires.toGMTString();
    }
    if (domain) {
      cookieText += '; domain=' + domain;
    }

    // 根据当前协议决定是否使用 Secure 和 SameSite
    if (location.protocol === 'https:') {
      cookieText += '; SameSite=None; Secure';
    } else {
      // HTTP 环境下使用相对宽松的设置
      cookieText += '; SameSite=Lax';
    }

    console.log('设置cookie:', cookieText);
    document.cookie = cookieText;
  },
  /*
     cookie不存在删除的方法,可以将某条cookie记录的有效期设置成过去式,就可以删除某条cookie记录了.
     */
  unset (name, path, domain, secure) {
    this.set(name, '', new Date(0), path, domain, secure);
  }
};
if (typeof window !== 'undefined') {
  window.CookieUtil = CookieUtil;
}

export default CookieUtil;
